import * as types from "../constants/actionConstants";
import TemplateApi from "../api/TemplateApi";
import * as TEMPLATE from "../constants/templateConstants";
import * as portalTypes from "../portal/constants/actionConstants";
import * as portalShared from "../portal/shared/metadataConstantsAndUtilities"
import {createEditorInstanceId, EDITOR_TYPES} from "../utilities/editorInstanceOwnership";


export function initializeQuestionnaireEditorCreate(template) {

    let tempClosePageObj = portalShared.getCustomQuestionnaireClosePageObj();
    //let tempAlertsObj = portalShared.getQuestionnaireAlertsObj("survey");

    let tempMetadata = {
        [portalShared.CUSTOM_QNR_CLOSE_PAGE_OBJ]: JSON.stringify(tempClosePageObj),
        //[portalShared.CUSTOM_DDO_QNR_FORMAT_ALERTS]: JSON.stringify(tempAlertsObj)
    }

    if (!template) {
        template = {
            metadata: {}
        };
    }


    return {
        type: types.QUESTIONNAIRE_EDITOR_INITIALIZE,
        payload: {
            instanceId: createEditorInstanceId(EDITOR_TYPES.QUESTIONNAIRE),
            template: {
                templateKey: (template.templateKey)? template.templateKey : "",
                name: (template.name)? template.name : "",
                nameQualifier: (template.nameQualifier)? template.nameQualifier : null,
                description: (template.description)? template.description : "",
                expirationDays: 7,
                expirationDescription: "You have either already completed this survey, or your survey link has expired.",
                metadata: {
                    ...tempMetadata
                },
                categoryKeys: [],
            },
            categoryKeys: [],
            questionKeys: [],
            options: {
                hasDescription: !!template.description,
                createMode: true,
                edited: true,
                validate: []
            }
        }
    };
}

export function initializeQuestionnaireEditorUpdate(template) {

    return {
        type: types.QUESTIONNAIRE_EDITOR_INITIALIZE,
        payload: {
            instanceId: createEditorInstanceId(EDITOR_TYPES.QUESTIONNAIRE),
            template: {
                ...template,
                startDate: null,
                endDate: null,
                publishedDate: null,
            },
            categoryKeys: template.categoryKeys,
            questionKeys: template.questionKeys,
            options: {
                hasScript: !!template.script,
                hasDescription: !!template.description,
                createMode: false,
                edited: false,
                validate: []
            }
        }
    };
}

export function updateQuestionnaireTemplate(template, options) {
    return (dispatch) => {
        dispatch({type: types.QUESTIONNAIRE_EDITOR_UPDATE, payload: {
                template,
                options: {
                    edited: true,
                    ...options
                }
            }});
        setTimeout(() => {
            dispatch({type: portalTypes.INCREMENT_PORTAL_COUNT});
        }, 500);
    };
}

export function clearQuestionnaireEditor() {
    return (dispatch) => {
        dispatch({type: types.CLEAR_QUESTIONNAIRE_GRAPH});
        dispatch({type: types.QUESTIONNAIRE_EDITOR_CLEAR});
        setTimeout(() => {
            dispatch({type: portalTypes.INCREMENT_PORTAL_COUNT});
        }, 500);
    };
}

export function setDefaultCategory(templateKey, origin = null) {
    return {
        type: types.QUESTIONNAIRE_EDITOR_SET_DEFAULT_CATEGORY,
        defaultCategory: templateKey,
        origin
    };
}

// export function checkQuestionnaireValue = (filter) => {
//     let thunk = (dispatch) => {
//         TemplateApi.checkQuestionnaireExists(filter).then((data) => {
//             dispatch({type: types.QUESTIONNAIRE_EDITOR_NAME_AND_QUALIFIER_EXISTS, list: data.collection});
//             dispatch({type: portalTypes.INCREMENT_PORTAL_COUNT});
//         });
//     };
//
//     thunk.meta = {
//         debounce: {
//             time: 1000,
//             key: "__questionnaireExistsCheck",
//             leading: false,
//             trailing: true
//         }
//     };
//
//     return thunk;
// };

let questionnaireValidationRequestId = 0;

const runQuestionnaireNameAndQualifierValidation = (name, qualifier, depth, immediate) => {
    return (dispatch) => {
        const requestId = ++questionnaireValidationRequestId;
        dispatch({
            type: types.QUESTIONNAIRE_EDITOR_NAME_AND_QUALIFIER_VALIDATING,
            depth,
            requestId
        });
        return dispatch(validateQuestionnaireNameAndQualifierExists(
            name,
            qualifier,
            depth,
            requestId,
            immediate
        ));
    };
};

export function validateQuestionnaireNameAndQualifierUnique(name, qualifier, depth = 0) {
    return runQuestionnaireNameAndQualifierValidation(name, qualifier, depth, false);
}

export function validateQuestionnaireNameAndQualifierUniqueImmediately(name, qualifier, depth = 0) {
    return runQuestionnaireNameAndQualifierValidation(name, qualifier, depth, true);
}

export function validateQuestionnaireNameAndQualifierExists(name, qualifier, depth = 0, requestId, immediate = false) {
    const nameQualifier = qualifier === null ? "" : qualifier;

    const thunk = (dispatch) => {
        let request;
        try {
            request = TemplateApi.checkTemplateNameAndQualifierExists(
                TEMPLATE.TYPE.QUESTIONNAIRE,
                name,
                nameQualifier
            );
        }
        catch (error) {
            request = Promise.reject(error);
        }

        return Promise.resolve(request)
            .then((data) => {
                const result = {
                    succeeded: true,
                    name,
                    nameQualifier: qualifier,
                    collection: data.collection
                };
                dispatch({
                    type: types.QUESTIONNAIRE_EDITOR_NAME_AND_QUALIFIER_EXISTS,
                    list: result.collection,
                    depth,
                    requestId
                });
                return result;
            })
            .catch((error) => {
                dispatch({
                    type: types.QUESTIONNAIRE_EDITOR_NAME_AND_QUALIFIER_VALIDATION_FAILED,
                    depth,
                    requestId
                });
                return {
                    succeeded: false,
                    name,
                    nameQualifier: qualifier,
                    error
                };
            });
    };

    if (!immediate) {
        thunk.meta = {
            debounce: {
                time: 1000,
                key: "__questionExistsCheck",
                leading: false,
                trailing: true
            }
        };
    }

    return thunk;
}

// export function checkNameQualifier(nameQualifier, id) {
//     let thunk = (dispatch) => {
//         TemplateApi.checkQuestionnaireNameQualifierExists(nameQualifier, id).then((data) => {
//
//             // NOTE: for name check if there is a dup the dup templates are returned so  have to trick the UI
//             // this returns {valid: true|false errors: null}
//             let results = [];
//             if (!data.valid) {
//                 results = [{name: "", nameQualifier: nameQualifier, templateKey: "", id: id }];
//             }
//
//             dispatch({type: types.QUESTIONNAIRE_NAME_QUALIFIER_EXISTS, list: results});
//         });
//     };
//
//     thunk.meta = {
//         debounce: {
//             time: 1000,
//             key: "__questionnaireExistsCheck",
//             leading: false,
//             trailing: true
//         }
//     };
//
//     return thunk;
// };

export function setQuestionnaireType(type) {
    return {
        type: types.QUESTIONNAIRE_EDITOR_SET_TYPE,
        questionnaireType: type
    };
}

// ---------------------------------------------------------------------------------------------------------------------
// Questionnaires will have associated categories
// ---------------------------------------------------------------------------------------------------------------------

export function addQuestionnaireCategory(category) {
    return (dispatch) => {
        dispatch({type: types.QUESTIONNAIRE_EDITOR_ADD_CATEGORY, category: category});
        setTimeout(() => {
            dispatch({type: portalTypes.INCREMENT_PORTAL_COUNT});
        }, 500);
    };
}

export function removeQuestionnaireCategory(index) {
    return (dispatch) => {
        dispatch({type: types.QUESTIONNAIRE_EDITOR_REMOVE_CATEGORY, index: index});
        setTimeout(() => {
            dispatch({type: portalTypes.INCREMENT_PORTAL_COUNT});
        }, 500);
    };
}

export function reorderQuestionnaireCategory(isUp, index) {
    return (dispatch) => {
        dispatch({type: types.QUESTIONNAIRE_EDITOR_REORDER, isUp: isUp, index: index});
        setTimeout(() => {
            dispatch({type: portalTypes.INCREMENT_PORTAL_COUNT});
        }, 500);
    };
}

// ---------------------------------------------------------------------------------------------------------------------
// Questionnaire needs to force portal count to work
// ---------------------------------------------------------------------------------------------------------------------

export function incrementPortalCount() {
    return (dispatch) => {
        dispatch({type: portalTypes.INCREMENT_PORTAL_COUNT});
    };
}

